import { useMemo, useState } from "react";

import FormComp from "../../Componentes/FormComp";
import Overlay from "../../Componentes/Overlay";
import Formulario from "../../Componentes/Utils/Formulario";
import Modal from "../../Componentes/Utils/Modal";
import { useModal } from "../../contexts/ModalContext";
import useApi from "../../hooks/useApi";

/* Motivo único que o XLSX de V.A consolida. */
const MOTIVO_VA = "VA OBRA / CARTÃO ALELO";

/**
 * Modal de Apontamento de V.A.
 *
 * Mesmo fluxo do Apontamento de Folha, mas restrito ao motivo
 * "VA OBRA / CARTÃO ALELO". Filtra `dados` por CC, mês e motivo
 * antes de enviar ao backend, que enriquece com data de nascimento
 * e CPF (TOTVS) e dispara um e-mail com o XLSX em anexo.
 */
const ModalApontamentoVa = ({ centrosCustoOpts = [], dados = [] }) => {

    const { closeModal } = useModal();
    const api = useApi();

    const [enviando, setEnviando] = useState(false);
    const [centrosSelecionados, setCentrosSelecionados] = useState([]);
    const [mes, setMes] = useState("");

    const ccOptions = useMemo(
        () => centrosCustoOpts.map((cc) => ({ value: cc, label: cc })),
        [centrosCustoOpts]
    );

    const mesAtual = useMemo(() => {
        const d = new Date();
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
    }, []);

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!centrosSelecionados || centrosSelecionados.length === 0) {
            alert("Selecione ao menos um centro de custo.");
            return;
        }

        if (!mes) {
            alert("Selecione o mês de referência.");
            return;
        }

        if (mes > mesAtual) {
            alert("Não é possível apontar V.A de um mês futuro.");
            return;
        }

        const ccsSelecionados = centrosSelecionados.map((o) => o.value);
        const ccsSet = new Set(ccsSelecionados);

        /* Filtra pelos CCs, mês e motivo "VA OBRA / CARTÃO ALELO". */
        const dadosFiltrados = (dados || []).filter((r) => {
            if (!r || !ccsSet.has(r.centro_custo)) return false;
            if (r.motivo !== MOTIVO_VA) return false;
            const dataStr = String(r.data || "");
            return dataStr.slice(0, 7) === mes;
        });

        if (dadosFiltrados.length === 0) {
            alert("Nenhum lançamento de V.A encontrado para os centros de custo e mês selecionados.");
            return;
        }

        try {

            setEnviando(true);

            const payload = {
                centros_custo: ccsSelecionados,
                mes,
                dados: dadosFiltrados,
            };

            const { data } = await api.post(
                "/Painel/API/FolhaPag/EnviarApontamentoVA/",
                payload
            );

            if (data?.status === "SUCCESS") {
                alert("Apontamento de V.A enviado com sucesso!");
                closeModal();
            } else {
                alert(data?.message || "Não foi possível enviar o apontamento de V.A.");
            }

        } catch (err) {

            console.error(err);
            const msg = err?.response?.data?.message || "Erro ao enviar apontamento de V.A.";
            alert(msg);

        } finally {

            setEnviando(false);

        }

    };

    return (
        <Overlay state={ true } >
            <Modal header close={ closeModal } >
                <Formulario onSubmit={ handleSubmit } >
                    <FormComp
                        title="CENTRO(S) DE CUSTO"
                        type="multiselect"
                        placeholder="SELECIONE UM OU MAIS CENTROS DE CUSTO"
                        options={ ccOptions }
                        valor={ centrosSelecionados }
                        changeFunc={ (selected) => setCentrosSelecionados(selected || []) }
                        required
                    />
                    <FormComp
                        title="MÊS DE REFERÊNCIA"
                        type="month"
                        valor={ mes }
                        name="mes"
                        changeFunc={ (e) => setMes(e.target.value) }
                        required
                    />
                    <FormComp
                        type="submit"
                        valor={ enviando ? "ENVIANDO..." : "ENVIAR APONTAMENTO V.A" }
                        disabled={ enviando }
                    />
                </Formulario>
            </Modal>
        </Overlay>
    );

};

export default ModalApontamentoVa;
